import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import FotoMosaico from "../components/fotografia/FotoMosaico";
import { FOTOS, hayPortafolio } from "../data/portafolio";
import { SEGMENTOS } from "../data/segmentos";
import { PAGES, breadcrumbJsonLd } from "../seo/config";

const crumbs = [
  { name: "Inicio", path: "/" },
  { name: "Portafolio", path: "/portafolio" },
];

const PortafolioPage = () => {
  const listo = hayPortafolio();

  return (
    <>
      <Seo
        title={PAGES.portafolio.title}
        description={PAGES.portafolio.description}
        keywords={PAGES.portafolio.keywords}
        path={PAGES.portafolio.path}
        jsonLd={[breadcrumbJsonLd(crumbs)]}
        noindex={!listo}
      />

      <section className="bg-navy-900 pb-20 pt-28 text-white md:pt-32">
        <div className="container-page">
          <h1 className="font-display text-display-md font-bold">Portafolio</h1>
          {listo ? (
            <p className="mt-4 max-w-xl text-navy-100">Trabajos reales: eventos y sesiones en estudio.</p>
          ) : (
            <p className="mt-4 max-w-xl text-navy-100">
              Esta página se publica cuando hay fotografías propias. No usamos banco de imágenes como
              portafolio. Mientras tanto, los precios están publicados.
            </p>
          )}
        </div>
      </section>

      {listo ? (
        <section className="bg-navy-900 pb-24">
          <div className="container-page">
            <FotoMosaico fotos={FOTOS} />
          </div>
        </section>
      ) : (
        <section className="bg-sand-50 py-20">
          <div className="container-page">
            <ul className="grid gap-4 sm:grid-cols-2">
              {SEGMENTOS.map((segmento) => (
                <li key={segmento.id}>
                  <Link to={segmento.path} className="block border-t border-navy-100 py-4 hover:text-navy-600">
                    <span className="font-display text-xl font-bold">{segmento.nombre}</span>
                    <span className="mt-1 block text-sm text-navy-500">{segmento.objeto}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}
    </>
  );
};

export default PortafolioPage;
